export default {
  OVERLAY: 'overlay',
  BANNER: 'banner'
};
